import { useNumberMask } from "@common/hooks/useMask";
import useCustomerInfoFromQuery from "@modules/query-string/hooks/useCustomerInfoFromQuery";
import useVehicleInfoFromQuery from "@modules/query-string/hooks/useVehicleInfoFromQuery";
import useSourceInfoFromQuery from "@modules/query-string/hooks/useSourceInfoFromQuery";
import { StartPurchaseRequest } from "../types/Purchase";

const useAftermarketPurchaseFromQuery = () => {
  const { unMaskPipe: unMaskNumberPipe } = useNumberMask();
  const vehicleInformation = useVehicleInfoFromQuery();
  const customerInformation = useCustomerInfoFromQuery();
  const {
    sourceAdId,
    sourceAppId,
    sourceLocationId,
    sourceSessionId,
    sourceUserId,
    sourceCtaId,
    source,
  } = useSourceInfoFromQuery();

  const mileageValue = vehicleInformation.odometer
    ? unMaskNumberPipe(vehicleInformation.odometer)
    : null;

  return {
    vin: vehicleInformation.vin,
    year: vehicleInformation.year,
    make: vehicleInformation.make,
    model: vehicleInformation.model,
    trim: vehicleInformation.trim,
    mileage: mileageValue,
    purchaseDate: vehicleInformation.purchaseDate,
    purchasePrice: vehicleInformation.purchasePrice
      ? unMaskNumberPipe(vehicleInformation.purchasePrice)
      : null,
    firstName: customerInformation.firstName,
    lastName: customerInformation.lastName,
    email: customerInformation.email,
    phone: customerInformation.phoneNumber,
    address: customerInformation.streetAddress,
    city: customerInformation.city,
    province: customerInformation.province?.abbr,
    postalCode: customerInformation.postalCode,
    coverImage: vehicleInformation.coverImage,
    fuelType: vehicleInformation.fuelType,
    sourceAdId,
    sourceAppId,
    sourceLocationId,
    sourceSessionId,
    sourceUserId,
    sourceCtaId,
    source,
  } as StartPurchaseRequest;
};

export default useAftermarketPurchaseFromQuery;
